// extracted by css-extract-rspack-plugin
var _1 = "QvWzb0rl8eQjARmm";
var _2 = "_s_dh0FCb4jKeTUd";
var _3 = "HPV8s6zHAFIMLWlh";
var _4 = "oq7zpNhuQgggnPRZ";
var _5 = "xFAtzfmfHL89J4ud";
var _6 = "Cp3UIqxWTLMhyjSN";
var _7 = "G0GyDFRVs8YaAmKc";
var _8 = "BpG2Sj_jFMwxbWx5";
var _9 = "TFDk957kZUYhoecN";
var _a = "HCG2q_UKXo_CLPjv";
var _b = "ZOcvOByJu3IIY_Ef";
var _c = "ENyYDvd4EIUL8pvH";
var _d = "fqqF_kIbbdUxbrX9";
export { _1 as "column", _2 as "contactBox", _3 as "copyright", _4 as "copyrightHolder", _5 as "footer", _6 as "langSwitcherWrap", _7 as "logo", _8 as "logoWithLangSwitcher", _9 as "panelList", _a as "panelMarginMid", _b as "panelsWrap", _c as "socialIcon", _d as "socialIconsHolder" }
// extracted by css-extract-rspack-plugin
var _1 = "QvWzb0rl8eQjARmm";
var _2 = "_s_dh0FCb4jKeTUd";
var _3 = "HPV8s6zHAFIMLWlh";
var _4 = "oq7zpNhuQgggnPRZ";
var _5 = "xFAtzfmfHL89J4ud";
var _6 = "Cp3UIqxWTLMhyjSN";
var _7 = "G0GyDFRVs8YaAmKc";
var _8 = "BpG2Sj_jFMwxbWx5";
var _9 = "TFDk957kZUYhoecN";
var _a = "HCG2q_UKXo_CLPjv";
var _b = "ZOcvOByJu3IIY_Ef";
var _c = "ENyYDvd4EIUL8pvH";
var _d = "fqqF_kIbbdUxbrX9";
export { _1 as "column", _2 as "contactBox", _3 as "copyright", _4 as "copyrightHolder", _5 as "footer", _6 as "langSwitcherWrap", _7 as "logo", _8 as "logoWithLangSwitcher", _9 as "panelList", _a as "panelMarginMid", _b as "panelsWrap", _c as "socialIcon", _d as "socialIconsHolder" }
